import { Chip, Tooltip } from '@mui/material';
import React from 'react';

const ResellStatusChip = (_value: any, row: any) => {
  if (row?.isResoldToFund) {
    return (
      <Tooltip title={row.resoldFundName ?? ''} placement="top" arrow>
        <Chip
          label="Vendida"
          size="small"
          color="primary"
          variant="outlined"
          sx={{ fontSize: '0.7rem', cursor: 'default' }}
        />
      </Tooltip>
    );
  }
  if (row?.isRebuyed) {
    return (
      <Chip
        label="Recomprada"
        size="small"
        variant="outlined"
        sx={{
          fontSize: '0.7rem',
          color: 'text.secondary',
          borderColor: 'text.secondary',
        }}
      />
    );
  }
  return (
    <Chip
      label="En cartera"
      size="small"
      variant="outlined"
      sx={{
        fontSize: '0.7rem',
        color: '#E8C547',
        borderColor: '#E8C547',
      }}
    />
  );
};

export default ResellStatusChip;
